import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CompanySelector from '../components/modal/CompanySelector';
import { hasSelectedCompany } from '../utils/companyUtils';
import Head from '../layout/head/Head';

const CompanySelection = () => {
  const [showSelector, setShowSelector] = useState(true);
  const history = useHistory();

  useEffect(() => {
    // Si ya tiene empresa seleccionada, redirigir al dashboard
    if (hasSelectedCompany()) {
      history.push('/');
    }
  }, [history]);

  useEffect(() => {
    document.title = "Selección de Empresa - Metrics";
  }, []);

  const handleCompanySelected = () => {
    setShowSelector(false);
    // Redirigir al dashboard
    history.push('/');
  };

  return (
    <>
      <Head title="Selección de Empresa" />
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>Metrics Platform</h1>
          <p style={styles.subtitle}>
            Selecciona tu empresa para continuar
          </p>
        </div>
        
        <CompanySelector
          isOpen={showSelector}
          onCompanySelected={handleCompanySelected}
        />
      </div>
    </>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  content: {
    textAlign: 'center',
    color: 'white',
    zIndex: 1
  },
  title: {
    fontSize: '48px',
    fontWeight: 'bold',
    margin: '0 0 16px 0',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
  },
  subtitle: {
    fontSize: '18px',
    opacity: 0.9,
    margin: 0
  }
};

export default CompanySelection;
